var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',_vm._b({attrs:{"size":_vm.pixelSize,"color":_vm.color}},"v-icon",_vm._d({},[_vm.stringSize,!!_vm.stringSize])),[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }